import { ServiceLoader } from 'components/common/Loading';
import { Layout } from 'components/Layout';
import React, { FC, Fragment, lazy, Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { RoutePaths } from './RoutePaths';
import { AvailableLanguages, useLanguage } from 'components/Layout/Language/useLanguage';

const TermsOfUseLayout = lazy(() => import('components/Pages/TermsOfUse/TermsOfUseLayout'));

export const AppRoutes: React.FC = () => {
    return <Layout>
        <Suspense fallback={<div className="d-flex justify-content-center"><ServiceLoader /></div>}>
            <Routes>
                {AvailableLanguages.map(lng => <Fragment key={lng}>
                    <Route path={RoutePaths.Home.route(lng)} element={<TermsOfUseLayout />} />
                    <Route path={RoutePaths.TermsOfUse.Client.route(lng)} element={<TermsOfUseLayout />} />
                    <Route path={RoutePaths.TermsOfUse.Contact.route(lng)} element={<TermsOfUseLayout />} />
                </Fragment>)}
                <Route path="*" element={<RedirectComponent />} />
            </Routes>
        </Suspense>
    </Layout>;
};

const RedirectComponent: FC = () => {
    const { selectedLanguage, urlLanguage } = useLanguage();
    const { pathname, search, hash } = useLocation();

    if (urlLanguage) {
        // Route already have language in URL, but no route where found. Redirect to the home
        return <Navigate to={RoutePaths.Home.url(urlLanguage)} />;
    }

    // Route doesn't have language in URL. Add it.
    return <Navigate to={`/${selectedLanguage}${pathname}${search}${hash}`} />;
};